import React, { ReactNode } from 'react';
import classNames from 'classnames';

export const IntentIntro = ({ children, className = 'mb-8' }: { children: ReactNode; className?: string }) => {
  return <p className={classNames('text-xl text-grey-6', className)}>{children}</p>;
};
